import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      filter: ({ filtersStore: { filter } }) => filter,
      queries: ({ resourcesStore: { queries } }) => queries,
    }),
  },
  methods: {
    activateLanguageFilter(type, id, title) {
      this.$store.commit('filtersStore/reset', type);
      let filterQuery = {
        type: type,
        id: id,
        title: title,
      };

      let updateQuery = JSON.parse(JSON.stringify(this.queries.videos));

      const currentFilters = updateQuery.filters;

      updateQuery.filters = {
        ...currentFilters,
        [type]: id 
      };
      updateQuery.pagination.page = 1;

      this.$store.commit('filtersStore/setFilter', filterQuery);
      this.$store.commit('resourcesStore/updateQuery', updateQuery);
      this.$store.dispatch('resourcesStore/getResources', updateQuery);

      if (!this.isMobile) {
        this.$store.commit('dropdownStore/setDropdown', false);
      }
    },
  }
}
